import BaseService from '@peoplenet/vi-components-ui/src/middleware/BaseService';

class SystemService extends BaseService {
  prefix = '/system';

  async updateName() {
    const companyName = await this.getCompanyName();

    await this.post({
      companyName,
    });
  }

  async getSettings() {
    return this.get('settings');
  }
}

export default new SystemService();
